// Add all new JS here

// clickable divs
jQuery(".click-me").click(function() {
  window.location = jQuery(this)
    .find("a")
    .attr("href");
  return false;
});

(function(jQuery) {
  /*
   *  new_map
   *
   *  This function will render a Google Map onto the selected jQuery element
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	jQueryel (jQuery element)
   *  @return	n/a
   */

  function new_map(jQueryel) {
    // var
    var jQuerymarkers = jQueryel.find(".marker");

    // vars
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    // create map
    var map = new google.maps.Map(jQueryel[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    jQuerymarkers.each(function() {
      add_marker(jQuery(this), map);
    });

    // center map
    center_map(map);

    // return
    return map;
  }

  /*
   *  add_marker
   *
   *  This function will add a marker to the selected Google Map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	jQuerymarker (jQuery element)
   *  @param	map (Google Map object)
   *  @return	n/a
   */

  function add_marker(jQuerymarker, map) {
    // var
    var latlng = new google.maps.LatLng(
      jQuerymarker.attr("data-lat"),
      jQuerymarker.attr("data-lng")
    );

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if (jQuerymarker.html()) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: jQuerymarker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, "click", function() {
        infowindow.open(map, marker);
      });
    }
  }

  /*
   *  center_map
   *
   *  This function will center the map, showing all markers attached to this map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	map (Google Map object)
   *  @return	n/a
   */

  function center_map(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    jQuery.each(map.markers, function(i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  }

  /*
   *  document ready
   *
   *  This function will render each map when the document is ready (page has loaded)
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	5.0.0
   *
   *  @param	n/a
   *  @return	n/a
   */
  // global var
  var map = null;

  jQuery(document).ready(function() {
    jQuery(".acf-map").each(function() {
      // create map
      map = new_map(jQuery(this));
    });
  });
})(jQuery);

// Owl
jQuery(document).ready(function() {
  var owl_related = jQuery(".related-products");
  owl_related.owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    nav: true,
    pagination: false,
    navText: [
      '<i class="fas fa-chevron-left carousel-arrow"></i>',
      '<i class="fas fa-chevron-right carousel-arrow"></i>'
    ],
    responsive: {
      0: {
        items: 1,
        nav: false
      },
      600: {
        items: 3,
        nav: false
      },
      1000: {
        items: 4,
        nav: true
      }
    }
  });

  var owl_hero= jQuery(".home-hero-slider");
  owl_hero.owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    animateOut: 'fadeOut',
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
  //  responsiveClass: true,
    dots: true,
  });

});

// Mobile nav 

//BURGER ICON CLICK

TweenMax.fromTo(
  ".burger_icon",
  0.4, {
      opacity: 0
  }, {
      opacity: 1
  }
);

//Burger Click

var tlburgerclick = new TimelineMax({
  paused: true
});

tlburgerclick
  .to(".moblie-nav", 0.2, {
      scale: 0,
      opacity: 0
  })
  .to(".full_screen_menu_inner", 0.2, {
      autoAlpha: 1
  })
  .from(".close_button_svg", 0.3, {
      rotation: 180,
      x: 100,
      opacity: 0
  })
  .staggerFrom(
      ".full_screen_menu_contents nav ul li",
      0.3, {
          y: 20,
          opacity: 0
      },
      0.1
  );

jQuery(".burger_icon").click(function () {
  tlburgerclick.play(0);
});

//Close button click

jQuery(".close_button_svg").click(function () {
  tlburgerclick.reverse();
});

// Scroll animations 

// init controller
jQuery(document).ready(function() {
  // init controller
  var controller = new ScrollMagic.Controller();
  
  
  
  // loop through all elements
  jQuery('.fade-up-img-big').each(function() {
  
    // build a tween
    var tween = TweenMax.from(jQuery(this), 0.2, {opacity:0.5, yPercent: 3, scale: 0.95, ease:Linear.easeNone});
  
    // build a scene
    var scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 'onEnter', offset: 203
    })
    .setTween(tween) // trigger a TweenMax.to tween
    .addTo(controller);
  
  });
  
  
  // loop through all elements
  jQuery('.fade-up').each(function() {
  
    // build a tween
    var tween = TweenMax.from(jQuery(this), 1, {opacity:0, yPercent: 10, ease:Linear.easeNone});
  
    // build a scene
    var scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 'onEnter', offset: 203
    })
    .setTween(tween) // trigger a TweenMax.to tween
    .addTo(controller);
  
  });
  
});